import useWindowDimensions from '@hooks/useWindowDimensions';
import { LoadingDots } from '@shared/atoms';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// Configuration mapping
const REDIRECT_CONFIG: Record<string, string> = {
  // Old URL (query string) : New URL (query string)
  'tabId=1&tabName=Overall&check-in=false': 'questionnaireId=2&check-in=false',
  'tabId=3&tabName=Mental&check-in=false': 'questionnaireId=3&check-in=false',
  'tabId=5&tabName=Physical&check-in=false': 'questionnaireId=4&check-in=false',
  'tabId=6&tabName=Financial&check-in=false': 'questionnaireId=5&check-in=false',
  'tabId=7&tabName=Social&check-in=false': 'questionnaireId=6&check-in=false',
  'tabId=2&tabName=Career&check-in=false': 'questionnaireId=7&check-in=false',

  // Without check-in parameter variations
  'tabId=1&tabName=Overall': 'questionnaireId=2',
  'tabId=3&tabName=Mental': 'questionnaireId=3',
  'tabId=5&tabName=Physical': 'questionnaireId=4',
  'tabId=6&tabName=Financial': 'questionnaireId=5',
  'tabId=7&tabName=Social': 'questionnaireId=6',
  'tabId=2&tabName=Career': 'questionnaireId=7',
};

export const CreateStarRedirect: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { isDesktop } = useWindowDimensions();

  useEffect(() => {
    const currentQuery = location.search.substring(1); // Remove the '?' prefix

    // Find matching configuration
    const newQuery = REDIRECT_CONFIG[currentQuery];

    if (newQuery) {
      const newUrl = `/assessment?${newQuery}`;
      history.replace(newUrl);
    } else {
      // Fallback: redirect to dashboard without parameters
      history.replace('/');
    }
  }, [location, history]);

  // Show loading or nothing while redirecting
  return (
    <div className="initialLoadingContainer">
      <LoadingDots size={isDesktop ? 24 : 20} isHapstarLoading dotCount={3} />
    </div>
  );
};
